"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const InfiniteIterator_1 = require("./InfiniteIterator");
class InfiniteStream {
    constructor(initial, func) {
        this.initial = initial;
        this.func = func;
        this.it = InfiniteIterator_1.default.of(initial, func);
    }
    static of(initial, func) {
        return new InfiniteStream(initial, func);
    }
    filter(filter) {
        let it = this.it;
        let initial;
        do {
            initial = it.next().value;
        } while (!filter(initial));
        return InfiniteStream.of(initial, previous => {
            let e;
            do {
                e = it.next().value;
            } while (!filter(e));
            return e;
        });
    }
    map(map) {
        let it = this.it;
        return InfiniteStream.of(map(it.next().value), previous => map(it.next().value));
    }
    limit(size) {
        let values = [];
        while (size-- > 0) {
            values.push(this.it.next().value);
        }
        return values;
    }
    skip(amount) {
        while (amount-- > 0) {
            this.it.next();
        }
        return this;
    }
}
exports.default = InfiniteStream;
